import { BriochePosition } from "./BriochePosition";
import { BriocheControllingClasses } from "./BriocheControllingClasses";
import { BriocheSettings } from "./BriocheSettings";
import { BriochePartFormatterClasses } from "./BriochePartFormatterClasses";
import { BriocheTheme } from "./BriocheTheme";

/**
 * Brioche position - position controlling classes map
 */
export const BRIOCHE_POSITION_CLASSES_MAP: {
  [key in BriochePosition]: BriocheControllingClasses;
} = {
  vertical: {
    classPosition: "vertical",
    classPositionActive: "active",
    classVisible: "visible"
  }
};

/**
 * Brioche theme - part formatting CSS classes map
 */
export const BRIOCHE_PART_FORMATTING_CLASSES_MAP: {
  [key in BriocheTheme]: BriochePartFormatterClasses;
} = {
  success: {
    mainPartClass: "part-main-default part-main-success",
    iconPartClass: "part-icon-default part-icon-success",
    contentPartClass: "",
    controlsPartClass: "part-controls-default"
  },
  error: {
    mainPartClass: "part-main-default part-main-error",
    iconPartClass: "part-icon-default part-icon-error",
    contentPartClass: "part-content-default part-content-error",
    controlsPartClass: "part-controls-default"
  }
};

/**
 * Default arguments of Brioche calls
 */
export const BRIOCHE_DEFAULT_ARGS: BriocheSettings = {
  content: "",
  theme: "success",
  position: "vertical",
  timeout: 2500,
  icon: null,
  iconPosition: "left",
  controls: null,
  animationTimeout: 250,
  // Sits above the Modal stack (base 10000, step 10) so toast messages remain
  // visible when one or more Modals are open.
  zIndex: 11000,
  ...BRIOCHE_POSITION_CLASSES_MAP["vertical"],
  ...BRIOCHE_PART_FORMATTING_CLASSES_MAP["success"],
  dismissFn: () => undefined
};

/**
 * A custom CSS property applied on the root element of the Brioche.
 * Works as a namespace.
 */
export const BRIOCHE_ROOT_SELECTOR = "nine-am-brioche-root-790416";

/**
 * Brioche will check if a designated wrapper element was assigned. Otherwise,
 * it will use `document.body`
 */
export const BRIOCHE_WRAPPER_SELECTOR = "[data-brioche-wrapper-node='true']";
